export enum DeviceEventType {
    FLOW = "FLOW",
    WEIGHING = "WEIGHING"
}
